import { h, Component } from 'preact';
import style from './style.css';

export default class CustomToggle extends Component {
  constructor(props) {
    super(props);
  }

  render({ isChecked, info, onToggleChange }) {
    return (
      <div className={`${style['control-box']}`}>
        <div className={`theme-heading ${style['toggle-wrapper']}`}>
          <label className={`${style.switch}`}>
            <input type="checkbox" checked={isChecked} onChange={onToggleChange} />
            <span className={`${style.slider} ${style.round}`} />
          </label>
          {info.label}
        </div>
        <p className={`${style['small-txt']}`}>{info.desc}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./checkout/components/toggle/index.js